import React from 'react';

import {StreamBankLink} from "../../Common/StreamBankLink";
import {usePermission} from "../../../Hooks/PermissionHooks";
import {useOrganizationProfileImage} from "../../../Hooks/useOrganizationProfileImage";

export const OrganizationNameTableColumn = (props) => {
    const { Value = null, rowData = {} } = props;
    
    const { organizationId = null } = rowData;
    
    const organizationImage = useOrganizationProfileImage(rowData)
    
    const hasPermission = usePermission();

    if(organizationId != null && hasPermission('create_organization')) {
        return <StreamBankLink
            className="sb-actionable-link"
            Href={"/organizations/" + organizationId}
        >
            <div className="d-flex align-items-center">
                <div className="pndlm-image-editor-preview">
                    {organizationImage ? <img src={organizationImage} alt=""/> : null}
                </div>
                <div className="sb-organization-name-link-text">
                    {Value}
                </div>
            </div>
        </StreamBankLink>;
    } else {
        return <p>{Value}</p>;
    }
}


